import request, { getHeaders } from 'app/utils/fetch';

const Paths = {
  intercomJwt: 'users/intercom-jwt',
};

export type FetchIntercomJwtResponse = {
  status: string;
  data?: {
    jwt: string;
    expiresAt?: number;
  };
};

export const fetchIntercomJwt = async (): Promise<FetchIntercomJwtResponse> => {
  const headers = await getHeaders();
  const response = await request(headers).get(Paths.intercomJwt);
  return response as FetchIntercomJwtResponse;
};
